export default "__VITE_ASSET__pNu1S9xD__"